import { useParams } from "react-router-dom";
import { useAuthStore } from "@/store/auth";

/**
 * Returns the organisation ID that the current page should operate against.
 *
 * Priority:
 *  1. URL parameter `:orgId` (when staff is acting on a specific org from /staff/organisations/:orgId/*)
 *  2. The signed-in user's own `organisation_id` (normal org-admin flow)
 *
 * Throws when neither is available (should not happen under the route guards).
 */
export function useOrgId(): string {
  const params = useParams<{ orgId?: string }>();
  const user = useAuthStore((s) => s.user);
  const orgId = params.orgId ?? user?.organisation_id ?? null;
  if (!orgId) throw new Error("No organisation context available");
  return orgId;
}

/** Returns true when the URL contains :orgId (staff is in another org's context). */
export function useIsStaffOrgContext(): boolean {
  const params = useParams<{ orgId?: string }>();
  return !!params.orgId;
}
